<template>
    <v-container>
        <v-layout>
            <v-flex xs12>
                <Suppliers></Suppliers>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Suppliers from "../../components/supplier/Suppliers.vue";

export default {
    components: {
        Suppliers
    },
    props: [
        
    ],
    data() {
        return {
            
        };
    },
    computed: {
        
    },
    methods: {
        
    }
};
</script>

<style>

</style>
